import { render, staticRenderFns } from "./RegisterStartupForm.vue?vue&type=template&id=348a0e58&scoped=true&"
import script from "./RegisterStartupForm.vue?vue&type=script&lang=js&"
export * from "./RegisterStartupForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterStartupForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RegisterStartupForm.vue?vue&type=style&index=1&id=348a0e58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a0e58",
  null
  
)

export default component.exports